module.exports = __webpack_public_path__ + "img/104.db3fe85e.png";